import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HubApp } from './HubApp.js';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <HubApp />
  </StrictMode>,
);
